export default __webpack_public_path__ + "static/media/quote-icon.b8d82771.svg";